<template>
  <w-sliding-popup ref="slidingPopup" title="스크립트 결과보기" width="800px" @close="close">
    <div slot="content">
      <el-input type="textarea" :readonly="true" :rows="43" :value="scriptContent" placeholder="스크립트 결과가 없습니다.">
      </el-input>
    </div>
  </w-sliding-popup>
</template>

<script>
export default {
  name: 'WScriptExecuteDetailShowPopup',
  props: {
    popupParams: {
      type: Object,
    },
  },
  data() {
    return {
      scriptContent: '',
    };
  },
  watch: {
    popupParams: {
      handler() {
        this.scriptContent = this.popupParams.jobResult;
      },
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/config/node/netdevice/components/ScriptExecuteDetailShowPopup.vue